module.exports = __webpack_public_path__ + "img/eqip5.e3b48845.png";